import * as React from 'react';

export const ThumbsUp = ({ width = 56, height = 50, fill = "#1E1E1E", ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 56 50" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M54.5 16.03C53.9368 15.3918 53.2443 14.8807 52.4685 14.5307C51.6926 14.1807 50.8512 13.9998 50 14H36V10C36 7.34784 34.9464 4.8043 33.0711 2.92893C31.1957 1.05357 28.6522 5.12756e-07 26 5.12756e-07C25.6284 -0.000265501 25.2642 0.102978 24.948 0.298154C24.6318 0.49333 24.3763 0.772722 24.21 1.105L14.765 20H4C2.93913 20 1.92172 20.4214 1.17157 21.1716C0.421427 21.9217 0 22.9391 0 24V46C0 47.0609 0.421427 48.0783 1.17157 48.8284C1.92172 49.5786 2.93913 50 4 50H47C48.4618 50.0005 49.8734 49.4674 50.9699 48.5007C52.0664 47.534 52.7723 46.2003 52.955 44.75L55.955 20.75C56.0613 19.9051 55.9866 19.0472 55.7357 18.2333C55.4848 17.4195 55.0636 16.6684 54.5 16.03ZM4 24H14V46H4V24Z"
        fill="#1E1E1E"
      />
    </svg>
  );
};
